import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
  Typography,
  Divider,
  Tooltip,
  IconButton,
  Popover
} from '@material-ui/core';
import { toCurrency } from 'utilities/format';
import { Constants } from 'utilities/constants';
import { Info as InfoIcon } from "@material-ui/icons";
import { UnderwriteAVM } from 'components/underwrite/shared'
import classNames from 'classnames';

const styles = theme => ({
  askingPrice: {
    paddingRight: '5px',
    lineHeight: '1.2'
  },
  detailsColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  askingPriceColumn: {
    display: 'flex',
    alignItems: 'center'
  },
  vertDivider: {
    width: 1,
    height: '100%',
    margin: '0 7px 0 4px'
  },
  grayBackground: {
    filter: 'grayscale(0.8) brightness(0.85) opacity(0.9)',
    backgroundColor: '#fff'
  }
});

const PriceSection = ({ classes, module, selectedContainer }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const showPopover = (e) => {
    setAnchorEl(e.currentTarget);
  }

  const handlePopoverClose = () => {
    setAnchorEl(null);
  }

  if (!selectedContainer) return;
  const shouldShowAskingPrice = module === Constants.Module.UNDERWRITE;
  const { sqft, normalAvm, askingPrice } = selectedContainer;
  const pricePerSqft = askingPrice && sqft && askingPrice / sqft;
  return (
    <>
      {shouldShowAskingPrice 
        ? <div className={classes.askingPriceColumn}>
            <Typography className={classes.askingPrice} variant="h6" noWrap>
              {askingPrice != null
                ? '$' + askingPrice.toLocaleString()
                : 'No asking price'
              }

            </Typography>
            {pricePerSqft != null && (
              <Typography variant="caption">
                ${pricePerSqft.toFixed(2).toLocaleString()}
                /sqft
              </Typography>
            )}
          </div>
        : null
      }
      {/* <TextDivider variant="h6" /> */}
      {normalAvm && sqft
        ? <>
            {shouldShowAskingPrice && <Divider className={classes.vertDivider} />}
            <Typography variant="caption" noWrap>
              AVM Normal <strong>{toCurrency(normalAvm, 0)}</strong> {toCurrency(normalAvm / sqft, 2)}/sqft
              </Typography>
            <Tooltip title=''>
              <IconButton size='small' onClick={showPopover} style={{ marginLeft: 4 }}>
                <InfoIcon fontSize='small' />
              </IconButton>
            </Tooltip>
            <Popover
              open={Boolean(anchorEl)}
              anchorEl={anchorEl}
              onClose={handlePopoverClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
            >
              <div className={classNames(selectedContainer?.viewingReadonlyMode && classes.grayBackground)} style={{ padding: '8px 16px' }}>
                <Typography variant='h6' style={{ marginBottom: 8, fontSize: '1rem' }}>AVM</Typography>
                <UnderwriteAVM selectedContainer={selectedContainer}/>
              </div>
            </Popover>
          </>
        : null
      }
    </>
  );
};


export default withStyles(styles)(PriceSection);
